import { api } from '@/lib/api';

export type OriginalPlusApplicationSubmitInput = {
  publicationName: string;
  contact: string;
  workTitle: string;
  description: string;
};

export type OriginalPlusApplicationSubmitPayload = OriginalPlusApplicationSubmitInput & {
  slug: 'selection';
};

export type OriginalPlusApplicationSubmitResponse = {
  success: boolean;
  message: string;
  id: number;
};

function buildApplicationPayload(
  input: OriginalPlusApplicationSubmitInput,
): OriginalPlusApplicationSubmitPayload {
  return {
    slug: 'selection',
    publicationName: input.publicationName.trim(),
    contact: input.contact.trim(),
    workTitle: input.workTitle.trim(),
    description: input.description,
  };
}

export async function submitOriginalPlusApplicationReq(
  input: OriginalPlusApplicationSubmitInput,
): Promise<OriginalPlusApplicationSubmitResponse> {
  const response = await api.post<OriginalPlusApplicationSubmitResponse>(
    '/api/konkurs',
    buildApplicationPayload(input),
  );

  return response.data;
}
